import React from 'react';
import styled from 'styled-components';

const SpanNcBarPriceBlock = styled.span`
    position: absolute;
    bottom: -23px;
    color: #999;
    font-size: 10px;
    word-break: keep-all;
    right: ${props => props.isMax ? '-15px' : ''};
`;

const SpanNcBarPrice = ({ value, isMax }) => {
    if (value === undefined || value === null) {
        return <SpanNcBarPriceBlock />
    }
    return (
        <SpanNcBarPriceBlock isMax={isMax}>
            {Number(value.toFixed(1)).toLocaleString()}
        </SpanNcBarPriceBlock>
    );
};

export default SpanNcBarPrice;